// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "static/css/main.c5d9cfdd.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "31d6cfe0" + ".chunk.css";
};